import React from 'react';
import ScriptRenderer from './script-engine/ScriptRenderer';

const Step4IncidenceDetails = ({ formData, updateFormData }) => {
  if (!formData.tipoIncidencia) {
    return (
      <div className="px-5 py-6">
        <div className="bg-red-50 border-2 border-red-100 rounded-xl px-4 py-5 text-center">
          <p className="text-sm font-semibold text-red-700">Tipo de incidencia no seleccionado</p>
          <p className="text-xs text-red-500 mt-1">Vuelve al paso anterior para seleccionar el tipo de servicio.</p>
        </div>
      </div>
    );
  }

  return <ScriptRenderer formData={formData} updateFormData={updateFormData} />;
};

export default Step4IncidenceDetails;
